import httpClient from '@/services/amio-api/http/amio-webapp.http-client'
import {handleSingleDataResponse, handleError} from '@/services/amio-api/utils/request-utils'
import assoc from 'ramda/src/assoc'
import dissoc from 'ramda/src/dissoc'

class SettingsService {
  constructor() {
    this.path = '/channels'
  }

  /**
   * The function removes 'channelId' from patchedSettings before GET.
   * It adds 'channelId' to the response.
   */
  get(channelId, ignoredHttpStatuses = []) {
    return httpClient
      .get(this._getPath(channelId))
      .then(handleSingleDataResponse)
      .then(settings => assoc('channelId', channelId, settings))
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  /**
   * The function removes 'channelId' from patchedSettings before PATCH.
   * It adds 'channelId' to the response.
   */
  patch(channelId, patchedSettings, ignoredHttpStatuses = []) {
    return httpClient
      .patch(this._getPath(channelId), dissoc('channelId', patchedSettings))
      .then(handleSingleDataResponse)
      .then(settings => assoc('channelId', channelId, settings))
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  _getPath(channelId) {
    return `/channels/${channelId}/settings`
  }
}

export default new SettingsService()
